import * as React from 'react';
import { connect } from 'react-redux';
import { WithTranslation, withTranslation } from 'react-i18next';
import clsx from 'clsx';

import { Icons, Switcher } from 'components';
import { Key } from 'utils';
import { IOperation, EOperationStatus } from 'types';
import { SearchType } from 'services/search/search-reducer';
import { IState } from 'services/root-reducer';
import { SearchInput } from '../search-input';

import './style.scss';

export interface ILogoProps extends React.HTMLAttributes<HTMLDivElement>, WithTranslation {
    logoText: string;
    inputValue: string;
    searchOperation: IOperation;
    activeTab: SearchType;
    pkkSettings: IState['app']['config']['publication']['settings']['customWidgets']['pkk_settings'];
    onTabChange: (new_tab: SearchType) => any;
    onInputValueChange: (input_value: string) => any;
    onPerformSearch: () => any;
    onBackButtonClick: () => any;
    onSearchEnabled: () => any;
    onSearchDisabled: () => any;
    showBackButton: boolean
}
export interface ILogoState {
    is_search_active: boolean;
    is_back_button_visible: boolean;
}

const mapStateToProps = (state: IState) => ({
    pkkSettings: state.app.config.publication.settings.customWidgets.pkk_settings
});

class LogoComponent extends React.Component<ILogoProps, ILogoState> {
    constructor(props: ILogoProps) {
        super(props);

        this.state = this.getInitialState();

        this.onCoatWrapperMouseEnter = this.onCoatWrapperMouseEnter.bind(this);
        this.onCoatWrapperMouseLeave = this.onCoatWrapperMouseLeave.bind(this);
        this.onCoatWrapperClick = this.onCoatWrapperClick.bind(this);
    }

    getInitialState(): ILogoState {
        return {
            is_search_active: false,
            is_back_button_visible: false
        };
    }

    /** Обработчик событий по наведению на иконку с гербом */
    onCoatWrapperMouseEnter() {
        this.setState({
            is_back_button_visible: true
        });
    }

    /** Обработчик событий по наведению на иконку с гербом */
    onCoatWrapperMouseLeave() {
        this.setState({
            is_back_button_visible: false
        });
    }

    /** Обработчик клика по гербу */
    onCoatWrapperClick() {
        if (this.state.is_back_button_visible) {
            this.props.onBackButtonClick();
        }
    }

    /** Рендерит либо герб либо стрелку "назад" */
    renderCoaIcon() {
        if (this.state.is_back_button_visible && this.props.showBackButton && !this.state.is_search_active) {
            return (
                <Icons.IconArrowLeft />
            );
        } else {
            return (
                <Icons.IconCoa3
                    onClick={() => {
                        window.location.reload();
                    }}
                />
            );
        }
    }

    /** Рендерит либо текст из `ILogoProps.logoText` либо инпут для поиска */
    renderTextInput() {
        let { searchOperation } = this.props;
        if (this.state.is_search_active) {
            return (
                <SearchInput
                    inputValue={this.props.inputValue}
                    searchOperation={searchOperation}
                    onCloseButtonClick={() => {
                        this.setState({
                            is_search_active: false
                        });
                        this.props.onSearchDisabled();
                    }}
                    onKeyDown={(event) => {
                        if (event.keyCode === Key.Enter) {
                            this.props.onPerformSearch();
                        }
                    }}
                    onSearchInputChange={(value) => {
                        this.props.onInputValueChange(value);
                    }}
                />
            );
        } else {
            return this.props.logoText;
        }
    }

    render() {
        let {
            logoText,
            activeTab,
            onTabChange,
            className,
            searchOperation,
            onBackButtonClick,
            onSearchDisabled,
            onSearchEnabled,
            onInputValueChange,
            inputValue,
            onPerformSearch,
            i18n,
            t,
            tReady,
            showBackButton,
            pkkSettings,
            ...restDivProps
        } = this.props;

        const searchTypes = [
            { code: SearchType.Objects, label: t('Объекты') },
            { code: SearchType.Address, label: t('Адрес') },
            { code: SearchType.Layers, label: t('Слои') }
        ];
        if (pkkSettings.values.pkk_search_enabled && i18n.language === 'ru') {
            searchTypes.push({ code: SearchType.PKK, label: t('ПКК') });
        }
        return (
            <div
                className={clsx('oms-logo', className)}
                {...restDivProps}
            >
                <div className="top-controlls-wrapper">
                    <div
                        className="coat-icon-wrapper"
                        onClick={this.onCoatWrapperClick}
                        onMouseEnter={this.onCoatWrapperMouseEnter}
                        onMouseLeave={this.onCoatWrapperMouseLeave}
                    >
                        {this.renderCoaIcon()}
                    </div>
                    <div className="text-input-wrapper">
                        {this.renderTextInput()}
                    </div>

                    {!this.state.is_search_active && (
                        <div
                            className="search-button"
                            onClick={() => {
                                this.setState({
                                    is_search_active: true
                                });
                                this.props.onSearchEnabled();
                            }}
                        >
                            <Icons.IconMagnifyGlass />
                        </div>
                    )}
                </div>
                {this.state.is_search_active && (
                    <Switcher
                        items={searchTypes}
                        className={clsx('tab-switcher-wrapper', {
                            'disabled': searchOperation?.status === EOperationStatus.PENDING
                        })}
                        value={this.props.activeTab}
                        onChange={(item) => {
                            this.props.onTabChange(item.code as SearchType);
                        }}
                    />
                )}
            </div>
        );
    }
}

export const Logo = withTranslation()(connect(mapStateToProps)(LogoComponent));
